<script setup>
  import { getTranslation } from '@/assets/scripts/getTranslation';
  import { useRoute } from 'vue-router';

  const props = defineProps({
    translations: Array
  });

  const route = useRoute();
  const otpCode = route.query["otpcode"];
</script>

<template>
  <main class="page-layout school-bg">

    <!-- Logo -->
    <div class="mb-4 text-center">
      <img :src="require(`@/assets/img/Edoki_logo.svg`)" alt="logo Montessori" class="edoki-logo">
    </div>

    <!-- White box (+ animated kids) -->
    <div class="whitebox gap-4 d-flex flex-column align-items-center">
      <div class="whitebox__title">
        {{ getTranslation('title-label', props.translations, $i18n.locale) }}
      </div>
      <div class="whitebox__subtitle home-subtitle" v-if="otpCode">
        {{ getTranslation('subtitle-label', props.translations, $i18n.locale) }}
      </div>
      <div class="whitebox__otp" v-if="otpCode">
        {{ otpCode }}
      </div>
      <div class="whitebox__subtitle home-subtitle" v-if="!otpCode">
        {{ getTranslation('app-label', props.translations, $i18n.locale) }}
      </div>
      <div class="whitebox__activation d-md-grid d-flex flex-column gap-lg-2 gap-1" v-if="!otpCode">
        <a href="https://appsto.re/ca/lOY2db.i?l=en" class="whitebox__activation-apple whitebox__activation-link" target="_blank">
          <img src="@/assets/img/AppStore-button.svg" alt="" class="whitebox__activation-img">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.edokicademy.montessoriacademy" class="whitebox__activation-google whitebox__activation-link" target="_blank">
          <img src="@/assets/img/GooglePlay-button.svg" alt=""  class="whitebox__activation-img">
        </a>
        <a href="https://www.amazon.com/Edoki-Academy-Montessori-Preschool/dp/B0747ZJ2C2" class="whitebox__activation-amazon whitebox__activation-link" target="_blank">
          <img src="@/assets/img/Amazon-button.svg" alt=""  class="whitebox__activation-img">
        </a>
      </div>
    </div>
    
  </main>
</template>

<style lang="scss">
  .home-subtitle {
    font-size: 2rem;
    font-weight: 700;

    @media (max-width: 992px) {
      font-size: 1.5rem;
    }
  }

  .edoki-logo {
    width: 20rem;

    @media (max-width: 992px) {
      width: 15rem;
    }
  }
</style>